
    import {defineComponent, computed, ref, reactive} from 'vue'

    import { helpers, requiredIf } from '@vuelidate/validators'
    import useVuelidate from '@vuelidate/core'
            
    import { ICuadroMetadatosUso } from '@/services/cuadro/cuadro'
    import { ITotalizacion }       from '@/services/cuadro/cuadro'
    import Cuadro                  from '@/services/cuadro/cuadro.service'
    import { IMetadatos }          from '@/services/artefactos/metadatos';
    import Metadatos               from '@/services/artefactos/metadatos.service';  
    import { PrimeIcons }          from 'primevue/api'

    import moment from 'moment'
    import * as XLSX from "xlsx-js-style"
    
    export default  defineComponent({ 
        name: 'difusionCuadro',

        props:{            
            idCuadro: null,
            conversion_medida: null
        },
        
        emits:['datasetTema'],

        data() {
            return {
                exportItems: [
                                {
                                    label: 'Formato XLSX',
                                    icon: PrimeIcons.FILE_EXCEL,
                                    command: () => {
                                        this.exportarCuadro('.xlsx')
                                    }
                                },
                                {
                                    label: 'Formato CSV',
                                    icon: PrimeIcons.FILE,
                                    command: () => {
                                        this.exportarCuadro('.csv')
                                    }
                                }
                            ]
            }
        },

        setup(){
            const error$ = ref({mostrar: false, msg: ''})  
            const mostrarFiltros = ref(false)
            const cuadroLoad = ref(false)

            //mas opciones
            const mostrarOpciones = ref(false)
            const mostrarBotonMasOpciones = ref(false)
            const masOpciones = ref({
                                    periodicidadNueva: null,
                                    //tipoOperacion: null,
                                    unidadOrigen: null,
                                    unidadDestino: null,
                                    tconversiones: []
                                })
            const catCuadroPeriodicidad = ref(null)
            const catCuadroUnidadMedida = ref(null)
            const catCuadroUnidadMedidaDestino = ref(null)
            const parametrosCuadro = ref({
                                    Id_cuadro: null,
                                    Fecha_inicio: null,
                                    Fecha_fin: null,
                                    Id_periodicidad_nva: null,
                                    Conversion: []
                                })  

            //servicios
            const servCuadro = ref(new (Cuadro))
            const operacionMetadatos = ref(new Metadatos);

            //data
            const cuadroMetadatos = ref<IMetadatos>({})
            const cuadroMetadatosUso = ref<ICuadroMetadatosUso[]>([])
            const cuadro = ref([])
            const cuadroHTML = ref([])
            const fechas = reactive({ fechaIni: new Date(new Date().getFullYear(), 0, 1), fechaFin: new Date() })
            const tipoControlFecha = ref()

            //metadata
            const fecha_cobertura_inicio = ref()
            const fecha_cobertura_termino = ref()
            const periodicidad = ref()
            const titulo_cuadro = ref()
            
            //xls
            const ws = ref(XLSX.utils.json_to_sheet([]))
            const wsSon = ref([])

            // #region validaciones            
            function minDate() {
                //console.log(value)value: any
                if( moment(this.fechas.fechaIni).isAfter(this.fechas.fechaFin)) { return false }
                return true
            }

            const rules = computed(() => {
                return {
                    fechaIni: { v1: helpers.withMessage("Se requiere una fecha inicio", requiredIf(fechas.fechaFin != null)),
                                v2: helpers.withMessage("La fecha inicio debe ser menor a la fecha término", minDate)
                              },
                    fechaFin: { v: helpers.withMessage("Se requiere una fecha término",  requiredIf(fechas.fechaIni != null)) }
                }
            })
                         
            const v$ = useVuelidate(rules, fechas) 
            // #endregion            

            return {
                     error$, v$, mostrarFiltros, 
                     fecha_cobertura_inicio, fecha_cobertura_termino, periodicidad, titulo_cuadro,
                     cuadroLoad, servCuadro, fechas, cuadroMetadatos, cuadroMetadatosUso,
                     cuadro, operacionMetadatos, cuadroHTML, ws, wsSon, 
                     mostrarOpciones, masOpciones, //mostrarErrorOpciones,
                     catCuadroPeriodicidad, catCuadroUnidadMedida, catCuadroUnidadMedidaDestino,
                     parametrosCuadro, mostrarBotonMasOpciones, tipoControlFecha
                    }
        },

        methods:{
            
            evalRespuestaAPI(response:any, toast?:boolean) {                
                if (response.success) {
                    if (toast){
                        if(response.data != null)this.$toast.add({severity:'success', summary: 'Información', detail: response.message, life: 10000})
                        else if(response.data.length == 0) this.$toast.add({severity:'info', summary: 'Información', detail: response.message, life: 10000})                                  
                    }
                }else{
                    if (response.errors.length > 0) {
                        response.errors.forEach((element: any) => {
                            this.$toast.add({severity:'warn', summary: 'Advertencia: ' + response.message, detail: element.message, life: 10000})
                        })
                    }else{
                        this.$toast.add({severity:'warn', summary: 'Advertencia', detail: response.message, life: 10000})
                    }
                } 

                return response.data
            },  

            getCuadro(){

                this.cuadroLoad = true

                this.servCuadro.ConsultarCuadros(this.idCuadro, this.fechas.fechaIni, this.fechas.fechaFin)      
                .then((response:any) => {
                    this.ws = XLSX.utils.json_to_sheet([])
                    this.cuadro = this.evalRespuestaAPI(response)                    

                    for (var i = 0; i < this.cuadro.length; i++ ){
                        XLSX.utils.sheet_add_aoa(this.ws, [this.cuadro[i].valor], { origin: this.cuadro[i].celda })                        
                        
                    }                        

                    this.cuadroHTML = XLSX.utils.sheet_to_html( this.aplicarVistaExcel() )                                      
                })
                .catch(error => { 
                    this.error$.mostrar = true
                    this.error$.msg = 'Al obtener Cuadro. ' + error
                })
                .finally(()=>{
                    this.cuadroLoad = false
                    this.formatoCuadroHTML()      
                }) 
            },

            aplicarVistaExcel(){
                this.wsSon = XLSX.utils.sheet_to_json(this.ws, {header: 1})                   
                for (var x = 1; x <= this.wsSon.length; x++ ){
                    this.wsSon[x-1].unshift(x)
                }    
                //console.log(this.wsSon)  
                XLSX.utils.json_to_sheet(this.wsSon, {skipHeader:true}) 
                return XLSX.utils.json_to_sheet(this.wsSon) 
            },

            numToColumn(num: number){
                var s = '', t;

                while (num > 0) {
                    t = (num - 1) % 26;
                    s = String.fromCharCode(65 + t) + s;
                    num = (num - t)/26 | 0;
                }
                return s || '';
            },   

            async getCuadroMetadatos(){
                
                return new Promise<void>((resolve) => {
                     //this.servCuadro.ListarCuadroMetadatos(this.idCuadro)             
                    this.operacionMetadatos.getMetadatos('2',this.idCuadro)             
                    .then((response:any) => {
                        
                        this.cuadroMetadatos = this.evalRespuestaAPI(response)

                        //fecha_cobertura_inicio, fecha_cobertura_termino, periodicidad, titulo_cuadro
                        let fecha_minima = this.cuadroMetadatos.find(item => item.metadato == "fecha_minima")
                        let fecha_maxima = this.cuadroMetadatos.find(item => item.metadato == "fecha_maxima")

                        this.titulo_cuadro = this.cuadroMetadatos.find(item => item.metadato == "nombre_cuadro").valor
                        this.periodicidad = this.cuadroMetadatos.find(item => item.metadato == "periodicidad").valor

                        this.fecha_cobertura_inicio = fecha_minima.valor
                        this.fecha_cobertura_termino = fecha_maxima.valor

                        let anio = new Date(fecha_maxima.valor).getFullYear()
                        let fi = new Date(anio - 3, 0, 1)  
                        this.fechas.fechaIni = new Date(fi)
                        this.fechas.fechaFin = moment(fecha_maxima.valor, "YYYY-MM-DD").toDate() //new Date(fecha_maxima.valor)                   

                        let posicion = this.cuadroMetadatos.indexOf(fecha_minima)

                        this.cuadroMetadatos.splice(posicion, 0, { 'metadato': 'cobertura', 'descripcion': 'Cobertura de tiempo', 'valor': (this.formatoFecha(fecha_minima.valor) + ' a ' + this.formatoFecha(fecha_maxima.valor)) })

                        this.cuadroMetadatos.splice(this.cuadroMetadatos.indexOf(fecha_minima), 1)
                        this.cuadroMetadatos.splice(this.cuadroMetadatos.indexOf(fecha_maxima), 1)

                        var tipo = this.cuadroMetadatos.filter(item => (item.metadato == 'periodicidad' && item.valor == 'Anual') || (item.metadato == 'nombre_tipo_plantilla' && item.valor == 'MATRIZ'))

                        if (tipo.length == 2) {
                            this.fechas.fechaIni = new Date(anio, 0, 1)
                            this.tipoControlFecha = "Anual"
                        }
                        else {
                            this.tipoControlFecha = "Rango"
                        }
                        //this.tipoControlFecha = (tipo.length) == 2 ? 'Anual' : 'Rango'

                        resolve()
                                        
                    })
                        .catch(error => { 
                        this.error$.mostrar = true
                        this.error$.msg = 'Al obtener Metadatos. ' + error
                    })  

                });

            },

            async getCuadroMetadatosUso() {

                return new Promise<void>((resolve) => {
                    this.servCuadro.ListarCuadroMetadatosUso(this.idCuadro) //this.servCuadro.ListarCuadroMetadatosUso(1) //
                        .then((response: any) => {

                            this.cuadroMetadatosUso = this.evalRespuestaAPI(response)
                            resolve()

                        })
                        .catch(error => {
                            this.error$.mostrar = true
                            this.error$.msg = 'Al obtener Metadatos: series del cuadro. ' + error
                        })

                });

            },

            exportarCuadro(ext: string){

                //console.log(String(this.idCuadro))

                if (ext == '.xlsx') this.formatoCuadroXLS()

                const workbook = XLSX.utils.book_new()
                XLSX.utils.book_append_sheet(workbook, this.ws, 'id-' + String(this.idCuadro))

                XLSX.writeFile(workbook, String(this.cuadroMetadatos.find(item => item.metadato == "nombre_cuadro").valor) + '-' + moment(String(new Date())).format('YYYY_MM_DD-hh_mm_ss-a') + ext);

            },       

            formatoCuadroHTML(){
                this.$nextTick(() => {

                    var vistaExcel = 1
                    //console.log('formatoCuadroHTML:',this.cuadro)
                    
                    for (var i = 0; i < this.cuadro.length; i++ ){                        

                        let celda = XLSX.utils.decode_cell(this.cuadro[i].celda)
                        let clases  = []

                        // negritas
                        if (this.cuadro[i].formato.length > 0 && JSON.parse(this.cuadro[i].formato).negrita == 1){
                            clases.push('font-bold')
                        }

                        // identacion 
                        if (this.cuadro[i].identacion > 0){  
                            clases.push('pl-' + (this.cuadro[i].identacion + 1))
                        }

                        this.cuadro[i].valor.forEach(() => {

                            // numerico
                            if (JSON.parse(this.cuadro[i].formato).numerico == 1) {

                                let x = document.querySelector('#sjs-' + XLSX.utils.encode_cell({ c: celda.c + vistaExcel, r: celda.r + vistaExcel }))
                                let num = parseFloat(x.textContent)
                                let decimales = 3 //((num % 1) == 0 ) ? 0 : 3
                                x.innerHTML = isNaN(num) ? x.textContent : num.toLocaleString('es-MX', { minimumFractionDigits: decimales, maximumFractionDigits: decimales })

                                document.querySelector('#sjs-' + XLSX.utils.encode_cell({ c: celda.c + vistaExcel, r: celda.r + vistaExcel })).classList.add('text-right') 
                            }
                            else if(clases.length > 0) {
                                clases.forEach((clase) => {
                                    document.querySelector('#sjs-' + XLSX.utils.encode_cell({ c: celda.c + vistaExcel, r: celda.r + vistaExcel })).classList.add(clase)                          
                                });
                            }

                            celda.c += 1
                        });                       
                        
                    }

                    // columnas
                    if (vistaExcel == 1){
                        var children = Array.from(document.querySelector('#sjs-A1').parentElement.children)
                        
                        children.forEach((child) => {
                            child.innerHTML = this.numToColumn(child.innerHTML)
                        })
                    }
                    
                }) 
            },

            formatoCuadroXLS(){
                for (var i=0; i< this.cuadro.length; i++){                    
                    let celda = XLSX.utils.decode_cell(this.cuadro[i].celda)

                    this.cuadro[i].valor.forEach((element: any) => {
                        // identacion
                        if (this.cuadro[i].identacion > 0){
                            this.ws[XLSX.utils.encode_cell(celda)].v = this.generarEspacios(this.cuadro[i].identacion) + element                                                   
                        }
                        // formato
                        if (this.cuadro[i].formato.length > 0){
                            // negritas
                            if (JSON.parse(this.cuadro[i].formato).negrita == 1){
                                this.ws[XLSX.utils.encode_cell(celda)].s = {	
                                    font: {
                                        bold: true,
                                    },
                                }                           
                            }
                            // numerico
                            if(JSON.parse(this.cuadro[i].formato).numerico == 1){
                                this.ws[XLSX.utils.encode_cell(celda)].t = 'n'
                                //this.ws[XLSX.utils.encode_cell(celda)].z = '0.0000'
                            }
                        }
                        celda.c += 1 
                    })
                }

                const wscols = [{wch:30}]
                this.ws['!cols'] = wscols
            },            

            generarEspacios(numEspacios: number){
                let espacios = ''
                for(var i=0; i< numEspacios; i++){
                    espacios += '   '
                }
                return espacios
            },

            formatoCampo(campo:string){
                return (campo.charAt(0).toUpperCase() + campo.slice(1))
                        .replace(/_/g,' ')
                        .replace(/sie/g,'SIE')
                        .replace(/cion/g,'ción')
                        .replace(/minima/g,'mínima')
                        .replace(/maxima/g,'máxima')
            },

            formatoFecha(fecha:Date) {
                return moment(fecha).format('DD/MM/YYYY')
            },

            validarFecha() {
                this.calcularFechaFin()
                this.v$.$validate() 
                //console.log(this.v$)

                if (!this.v$.$error) {
                    if (this.parametrosCuadro.Id_periodicidad_nva != null || this.parametrosCuadro.Conversion.length > 0){
                        this.obtenerVistaParametros()
                    }
                    else{
                        this.getCuadro()
                    }
                }
            },

            getPeriodicidadCuadro(){

                this.servCuadro.getPeriodicidadCuadro(this.idCuadro).then((response:any)=>{

                    //console.log(response)
                    this.catCuadroPeriodicidad = this.evalRespuestaAPI(response)
                    if (this.catCuadroPeriodicidad.length > 0)
                        this.masOpciones.periodicidadNueva = this.catCuadroPeriodicidad[0].id_periodicidad_destino

                })

            },

            getCuadroUnidadMedidaOrigen(){

                this.servCuadro.getCuadroUnidadMedidaOrigen(this.idCuadro).then((response:any)=>{

                    //console.log(response)
                    this.catCuadroUnidadMedida = this.evalRespuestaAPI(response)                    
                    /*if (this.catCuadroUnidadMedida.length == 1){
                        this.masOpciones.unidadOrigen = this.catCuadroUnidadMedida[0].id_unidad_medida
                    }*/
                })

            },

            getCuadroUnidadMedidaDestino(){

                this.servCuadro.getCuadroUnidadMedidaDestino(this.masOpciones.unidadOrigen).then((response:any)=>{

                    //console.log(response)
                    this.catCuadroUnidadMedidaDestino = this.evalRespuestaAPI(response)
                })

            },
            
            agregarConversion(){

                // valida que haya seleccion
                if (this.masOpciones.unidadOrigen == null || this.masOpciones.unidadDestino == null){
                    return
                }

                // valida que no este la conversion agregada
                const unidadOrigenVal = this.masOpciones.tconversiones.find((o) => o.Origen_id_unidad_medida == this.masOpciones.unidadOrigen)
                if (unidadOrigenVal != undefined){
                    return
                }

                // obtiene las unidades
                const UnidadOrigen = this.catCuadroUnidadMedida.find((o) => o.id_unidad_medida == this.masOpciones.unidadOrigen)
                const UnidadDestino = this.catCuadroUnidadMedidaDestino.find((o) => o.id_unidad_medida_destino == this.masOpciones.unidadDestino)
         
                // agrega la conversion a la tabla
                this.masOpciones.tconversiones.push({
                    "conversion": UnidadOrigen.unidad_medida + ' --> ' + UnidadDestino.unidad_medida_destino,  
                    "Origen_id_unidad_medida": UnidadOrigen.id_unidad_medida, 
                    "Origen_unidad_medida": UnidadOrigen.unidad_medida,
                    "Destino_id_unidad_medida": UnidadDestino.id_unidad_medida_destino,
                    "Destino_unidad_medida": UnidadDestino.unidad_medida_destino
                })
            },
            
            eliminaConversion(conversion){

                const index = this.masOpciones.tconversiones.findIndex(o => o.conversion === conversion.conversion)
                //console.log(index)

                if (index > -1){
                    this.masOpciones.tconversiones.splice(index, 1)
                }
            },

            limpiarModalOpciones(){

                this.mostrarErrorOpciones = false
                this.catCuadroUnidadMedidaDestino = null
                this.masOpciones = {
                                    periodicidadNueva: null,
                                    unidadOrigen: null,
                                    unidadDestino: null,
                                    tconversiones: []
                                   }

                this.parametrosCuadro = {
                                         Id_cuadro: null,
                                         Fecha_inicio: null,
                                         Fecha_fin: null,
                                         Id_periodicidad_nva: null,
                                         Conversion: []
                                        }

                if (this.catCuadroPeriodicidad.length > 0)
                    this.masOpciones.periodicidadNueva = this.catCuadroPeriodicidad[0].id_periodicidad_destino
                    
                this.mostrarOpciones = false 

                this.getCuadro()
            },

            obtenerVistaParametros(){
                
                /*if(this.masOpciones.periodicidadNueva != null || this.masOpciones.tipoOperacion != null){
                    if(this.masOpciones.periodicidadNueva == null || this.masOpciones.tipoOperacion == null){
                        this.mostrarErrorOpciones = true
                        return
                    }
                }*/

                //validar seleccion de totalizacion
                if(this.masOpciones.periodicidadNueva != null){
                    const periodicidadNueva = this.catCuadroPeriodicidad.find((o) => o.id_periodicidad_destino == this.masOpciones.periodicidadNueva).periodicidad_destino
                    if(periodicidadNueva == this.periodicidad && this.masOpciones.tconversiones.length == 0){
                        this.limpiarModalOpciones()
                        return
                    }

                    this.parametrosCuadro.Id_periodicidad_nva = this.masOpciones.periodicidadNueva
                }

                //validar la seleccion de conversion
                this.parametrosCuadro.Conversion = this.masOpciones.tconversiones.map(
                                                        ({Origen_id_unidad_medida, Origen_unidad_medida, Destino_id_unidad_medida, Destino_unidad_medida}) => 
                                                        ({Origen_id_unidad_medida, Origen_unidad_medida, Destino_id_unidad_medida, Destino_unidad_medida})
                                                    )


                //valida si hay alguna seleccion
                if (this.parametrosCuadro.Id_periodicidad_nva != null || this.parametrosCuadro.Conversion.length > 0){
                    this.parametrosCuadro.Id_cuadro = this.idCuadro
                    this.parametrosCuadro.Fecha_inicio = this.fechas.fechaIni
                    this.parametrosCuadro.Fecha_fin = this.fechas.fechaFin
                    //console.log(JSON.stringify(this.parametrosCuadro))

                    this.getCuadroParametros()
                    this.mostrarOpciones = false;
                }else{
                    this.$toast.add({severity:'info', summary: 'Información', detail: 'La selección está vacía', life: 3000})    
                }

            },

            getCuadroParametros(){

                this.cuadroLoad = true

                this.servCuadro.getTotalizacion(this.parametrosCuadro)    
                .then((response:any) => {
                    //console.log(response)
                    this.ws = XLSX.utils.json_to_sheet([])
                    this.cuadro = this.evalRespuestaAPI(response)                    

                    for (var i = 0; i < this.cuadro.length; i++ ){
                        XLSX.utils.sheet_add_aoa(this.ws, [this.cuadro[i].valor], { origin: this.cuadro[i].celda }) 
                    }                        

                    this.cuadroHTML = XLSX.utils.sheet_to_html( this.aplicarVistaExcel() )                                      
                })
                .catch(error => { 
                    this.error$.mostrar = true
                    this.error$.msg = 'Al obtener Cuadro. ' + error
                })
                .finally(()=>{
                    this.cuadroLoad = false
                    this.formatoCuadroHTML()      
                }) 
            },

            async getCuadroDatos(){
                

                this.servCuadro.ConsultarCuadro(this.idCuadro)             
                .then((response:any) => {

                    this.evalRespuestaAPI(response)

                    if (response.success && response.data[0].id_tipo_plantilla == 1){
                        this.mostrarBotonMasOpciones = true
                    }
                    
                                    
                })
                    .catch((error: string) => { 
                    this.error$.mostrar = true
                    this.error$.msg = 'Al obtener datos extra del cuadro. ' + error
                })  

            },

            calcularFechaFin() {
                if (this.tipoControlFecha == 'Anual')
                    this.fechas.fechaFin = new Date(new Date(this.fechas.fechaIni).getFullYear(), 11, 31)
            }
        },

        beforeMount(){
            //console.log(this.idCuadro)
            if (this.idCuadro !== null){
                this.getCuadroMetadatos().then(()=>{ 
                    this.getCuadro()
                    this.getCuadroDatos()
                    this.getCuadroMetadatosUso()
                    this.getPeriodicidadCuadro()
                    this.getCuadroUnidadMedidaOrigen()
                })
            }                 
        },
    }); 
